import { useQuery } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import { Party } from '@/api/types/backend-dto-types';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export const useGetMatterParties = (matterId?: string) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<Party[]>(
    [QueryEntity.MatterParties, { matterId }],
    async () => {
      const response = await fetch(`${APIBaseChronos}/api/matters/${matterId}/parties`, fetchConfigGET);
      if (!response.ok) throw new Error('Failed to fetch matter parties');
      return response.json();
    },
    { enabled: !!matterId },
  );
};
